import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const BiographySection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="biographySection"
      title={t('client.client.biography.title')}
    >
      <FormContent />
    </Section>
  );
};
